import { render, staticRenderFns } from "./Sorties.vue?vue&type=template&id=6b1905f8"
import script from "./Sorties.vue?vue&type=script&lang=js"
export * from "./Sorties.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports